window.onload = function () {
  let products = document.querySelectorAll('.product')

  products.forEach((product) => {
    const productImage = product.querySelector('img')

    if (productImage.src.includes('no-image')) {
      product.remove()
    }
  })
}
